import { useProcurifyIntl } from '@webapp/hooks'
import { type TaxType, TaxTypes } from '@webapp/models/enums/Tax'
import messages from '../messages'

export interface ICustomTaxOption {
  name: string
  type: TaxType
}

export const useNoTaxOptions = (): ICustomTaxOption[] => {
  const intl = useProcurifyIntl()
  return [
    {
      name: intl.formatMessage(messages.noTaxOptionLabel),
      type: null,
    },
  ]
}

export const useCustomTaxOptions = (): ICustomTaxOption[] => {
  const intl = useProcurifyIntl()
  return [
    {
      name: intl.formatMessage(messages.customAmountOptionLabel),
      type: TaxTypes.AMOUNT,
    },
    {
      name: intl.formatMessage(messages.customPercentageOptionLabel),
      type: TaxTypes.PERCENT,
    },
  ]
}

export const useCustomTaxGroupedOptions = () => {
  const intl = useProcurifyIntl()

  return [
    {
      label: '',
      options: useNoTaxOptions(),
    },
    {
      label: intl.formatMessage(messages.customOptionGroupLabel),
      options: useCustomTaxOptions(),
    },
  ]
}
